import { Component, Output, Input, OnChanges, EventEmitter} from '@angular/core';
import { MatDialog } from '@angular/material';
import {
  Conference,
  Timeline,
  Date,
  DateTimeFrame,
  User,
  CONFERENCE_TYPES,
 } from '../../../shared';
import { RoomConferenceInfoDialogComponent } from '../room-conference-info-dialog/room-conference-info-dialog.component';
import { MyConferenceInfoDialogComponent } from '../my-conference-info-dialog/my-conference-info-dialog.component';

@Component({
  selector: 'app-weekly-schedule',
  templateUrl: './weekly-schedule.component.html',
  styleUrls: ['./weekly-schedule.component.css']
})
export class WeeklyScheduleComponent implements OnChanges {
  @Input() user: User;
  @Input() conferences: Conference[];
  @Input() dateTimeFrame: DateTimeFrame;
  @Output() cancelConference: EventEmitter<Conference> = new EventEmitter();
  tableMatrix: Map<Date, Map<Timeline, Conference>>;

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnChanges() {
    if (this.dateTimeFrame && this.conferences){
      this.parseConferences();
    }
  }

  /**
   * Fills up tableMatrix object with dates, timelines and corresponding conferences
   */
  parseConferences() {
    this.tableMatrix = new Map<Date, Map<Timeline, Conference>>();
    for (let date of this.dateTimeFrame.dates) {
      this.tableMatrix.set(date, new Map<Timeline, Conference>());

      for (let timeline of this.dateTimeFrame.timelines) {
        this.tableMatrix.get(date).set(timeline, null);

        for (let conference of this.conferences) {
          if (this.isStartOfConference(date, timeline, conference)) {
            this.tableMatrix.get(date).set(timeline, conference);
          }
        }
      }
    }
  }

  isStartOfConference(date: Date, timeline: Timeline, conference: Conference): boolean {
    return date.day == conference.date.day && timeline.id == conference.timelines[0].id;
  }

  iffy(conference: Conference): boolean {
    return conference.type == CONFERENCE_TYPES.IFFY;
  }
  
  /**
   * Utilized in the template, during schedule table constructing.
   * 
   * @param date 
   * @param timeline 
   */
  isEmptyCell(date: Date, timeline: Timeline) {
    if (this.conferences) {
      for (let conference of this.conferences) {
        if (conference.date.day === date.day
          && conference.timelines.find(t => t.id === timeline.id)) {
            return false;
          }
      }
    } 
    return true;
  }

  showConferenceDialog(conference: Conference) {
    if (this.user) {
      let dialogRef = this.dialog.open(MyConferenceInfoDialogComponent, {
        width: '500px',
        data: { user: this.user, conference: conference }
      });
      dialogRef.componentInstance.cancelConference.subscribe(event => this.onCancelConference(event));
    } else {
      this.dialog.open(RoomConferenceInfoDialogComponent, {
        width: '500px',
        data: { conference: conference }
      });
    }
  }

  onCancelConference(conference: Conference) {
    this.cancelConference.emit(conference);
    console.log(this.cancelConference);
  }

}



// WEBPACK FOOTER //
// ./src/app/schedule/components/weekly-schedule/weekly-schedule.component.ts